import logoSavio from "../../assets/images/logo_Savio.png";
import { LogoImg } from "./ManufacturerLogo.styles";
type Props = {
  manufacturer?: string;
};

export const ManufacturerLogo: React.FC<Props> = (props: Props) => {
  let imgUrl;
  switch (props.manufacturer) {
    case "savio":
      imgUrl = logoSavio;
      break;
    default:
      break;
  }
  if (imgUrl) return <LogoImg src={imgUrl} alt={props.manufacturer}></LogoImg>;
  else return <></>;
};
